import React, {useEffect, useState} from "react";
import {changeStatus, create, getById, update} from "../../../services/purchase.service";
import {getById as getFileById} from "../../../services/file.service";
import {getActiveAccounts} from "../../../services/account.service";
import {getActiveCategories} from "../../../services/category.service";
import {getActiveInvoiceTypes} from "../../../services/invoice-type.service";
import {getActiveProviders} from "../../../services/provider.service";
import {NavigateFunction, NavLink, useNavigate, useParams, useLocation} from "react-router-dom";
import * as Yup from 'yup';
import {useFormik} from 'formik';
import {
  AutocompleteInputChangeReason,
  Chip as ChipMaterial,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField
} from "@mui/material";
import {GridSaveAltIcon} from "@mui/x-data-grid";
import {ArrowBackIosNew} from "@mui/icons-material";
import showNotification from "../../utils/Notify";
import {Alert, Box, Breadcrumbs, Button, Card, Chip, Grid, Stack, Typography} from "@mui/joy";
import {Experimental_CssVarsProvider as CssVarsProvider} from "@mui/material/styles";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import moment, {Moment} from "moment";
import IPurchase from "../../../types/purchase.type";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import IAccount from "../../../types/account.type";
import ICategory from "../../../types/category.type";
import IInvoiceType from "../../../types/incoice-type.type";
import IProvider from "../../../types/provider.type";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {Autocomplete} from "@mui/lab";
import {findServiceOrders, getById as getServiceOrderById} from "../../../services/service-order.service";
import IServiceOrder from "../../../types/service-order.type";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import IconButton from "@mui/joy/IconButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import IFile from "../../../types/file.type";
import {PurchaseApprovalStatus} from "../../../types/enumeration/PurchaseApprovalStatus";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import {PurchaseApprovalStatusNames} from "../../../types/enumeration/PurchaseApprovalStatusNames";
import {PurchaseApprovalStatusColors} from "../../../types/enumeration/PurchaseApprovalStatusColors";
import StatusHistoryModal from "../../utils/StatusHistoryModal";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ConfirmationModal from "../../utils/ConfirmationModal";
import IPurchaseApprovalChangeStatus from "../../../types/purchase-approval-change-status.type";
import {PurchaseViewFrom} from "../../../types/enumeration/PurchaseViewFrom";
import WarningIcon from '@mui/icons-material/Warning';
import {CashBoxStatus} from "../../../types/enumeration/CashBoxStatus";
import {LiquidationStatus} from "../../../types/enumeration/LiquidationStatus";
import {PaymentMethod} from "../../../types/enumeration/PaymentMethod";
import {PaymentMethodNames} from "../../../types/enumeration/PaymentMethodNames";
import {downloadFile} from "../../../services/file-download.service";

interface FormViewProps {
  viewFrom: PurchaseViewFrom;
}

export const PurchaseForm: React.FC<FormViewProps> = (props) => {
  const { viewFrom } = props;
  let navigate: NavigateFunction = useNavigate();
  const {state} = useLocation();
  const { id, cashBoxId, liquidationId } = useParams();
  const [accounts, setAccounts] = useState<Array<IAccount>>([]);
  const [categories, setCategories] = useState<Array<ICategory>>([]);
  const [invoiceTypes, setInvoiceTypes] = useState<Array<IInvoiceType>>([]);
  const [providers, setProviders] = useState<Array<IProvider>>([]);
  const [selectedServiceOrder, setSelectedServiceOrder] = useState<any>(null);
  const [serviceOrders, setServiceOrders] = useState<Array<IServiceOrder>>([]);
  const [selectedSection, setSelectedSection] = React.useState(window.location.pathname.split( '/')[1]);
  const [selectedNewStatus, setSelectedNewStatus] = React.useState<PurchaseApprovalStatus | null>(null);
  const [statusHistoryModalOpen, setStatusHistoryModalOpen] = React.useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState("");
  const [modalMessage, setModalMessage] = React.useState("");
  const [preSelectedServiceOrderId, setPreSelectedServiceOrderId] = React.useState(state?.serviceOrder ? state.serviceOrder : null);

  const initialValues: IPurchase = {
    id: null,
    account: null,
    invoiceDate: null,
    imputationPeriod: null,
    invoiceNumber: "",
    invoiceType: null,
    provider: null,
    category: null,
    serviceOrder: undefined,
    invoiceFile: null,
    uploadInvoiceFile: null,
    exemptAmount: 0,
    iibbPerceptions: 0,
    iva105: 0,
    iva21: 0,
    iva27: 0,
    ivaPerceptions: 0,
    netTaxed105: 0,
    netTaxed21: 0,
    netTaxed27: 0,
    totalAmount: 0,
    cashBoxId: cashBoxId ? cashBoxId : null,
    cashBoxStatus: null,
    liquidationId: liquidationId ? liquidationId : null,
    liquidationStatus: null,
    approvalStatus: viewFrom === PurchaseViewFrom.ADMINISTRATION_PANEL ? PurchaseApprovalStatus.VALIDATED : PurchaseApprovalStatus.PENDING_REVIEW,
    statusHistory: [],
    paid: "false",
    paymentMethod: null,
    comments: "",
  };

  const [purchase, setPurchase] = useState<IPurchase>(initialValues);

  const validationSchema = Yup.object({
    account: Yup.object().when([], {
      is: () => (viewFrom === PurchaseViewFrom.ADMINISTRATION_PANEL || viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION),
      then: (schema) => schema.required('La Cuenta es requerida'),
      otherwise: (schema) => schema.notRequired(),
    }),
    category: Yup.object().when([], {
      is: () => (viewFrom === PurchaseViewFrom.ADMINISTRATION_PANEL || viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION),
      then: (schema) => schema.required('La Categoria es requerida'),
      otherwise: (schema) => schema.notRequired(),
    }),
    imputationPeriod: Yup.string().when([], {
      is: () => (viewFrom === PurchaseViewFrom.ADMINISTRATION_PANEL || viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION),
      then: (schema) => schema.required('El Periodo IVA es requerido'),
      otherwise: (schema) => schema.notRequired(),
    }),
    paid: Yup.string().when([], {
      is: () => (viewFrom === PurchaseViewFrom.ADMINISTRATION_PANEL || viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION),
      then: (schema) => schema.required('El estado del pago es requerido'),
      otherwise: (schema) => schema.notRequired(),
    }),
    paymentMethod: Yup.string().when([], {
      is: () => (viewFrom === PurchaseViewFrom.ADMINISTRATION_PANEL || viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION),
      then: (schema) => schema.required('El Metodo de Pago es requerido'),
      otherwise: (schema) => schema.notRequired(),
    }),
    invoiceType: Yup.object().required('El Tipo es requerido'),
    invoiceDate: Yup.date().required('La Fecha es requerida'),
    invoiceNumber: Yup.string().required('El Numero de Comprobante es requerido'),
    exemptAmount: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto Exento es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto Exento es requerido').min(0, "El valor minimo es 0");
      }
    }),
    iva21: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto IVA 21% es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto IVA 21% es requerido').min(0, "El valor minimo es 0");
      }
    }),
    netTaxed21: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto Neto Grabado 21% es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto Neto Grabado 21% es requerido').min(0, "El valor minimo es 0");
      }
    }),
    iva105: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto IVA 10,5% es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto IVA 10,5% es requerido').min(0, "El valor minimo es 0");
      }
    }),
    netTaxed105: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto Neto Grabado 10,5% es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto Neto Grabado 10,5% es requerido').min(0, "El valor minimo es 0");
      }
    }),
    iva27: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto IVA 27% es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto IVA 27% es requerido').min(0, "El valor minimo es 0");
      }
    }),
    netTaxed27: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto Neto Grabado 27% es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto Neto Grabado 27% es requerido').min(0, "El valor minimo es 0");
      }
    }),
    ivaPerceptions: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto Percepciones IVA es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto Percepciones IVA es requerido').min(0, "El valor minimo es 0");
      }
    }),
    iibbPerceptions: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto Percepciones IIBB es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto Percepciones IIBB es requerido').min(0, "El valor minimo es 0");
      }
    }),
    totalAmount: Yup.number().when('invoiceType', (invoiceType: any, schema)=> {
      if (invoiceType[0]?.id === 6) {
        return schema.required('El monto Total es requerido').max(0, "El valor no puede ser mayor a 0");
      } else {
        return schema.required('El monto Total es requerido').min(0, "El valor minimo es 0");
      }
    }),
    provider: Yup.object().when(['invoiceType'], ([invoiceType], schema) => {
      if ((invoiceType?.name === "A" || invoiceType?.name === "B" || invoiceType?.name === "C")) {
        return schema.required('El Proveedor es requerido para tipos A, B y C');
      }
      return schema.notRequired();
    }),
  });

  const onSubmit = (purchase: IPurchase) => {
    if (id) {
      update(purchase.id, purchase)
        .then(() => {
          showNotification({type: 'success', message: 'Compra acutalidaza correctamente.'});
          if (((viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION || viewFrom === PurchaseViewFrom.CASH_BOX_REPORTING)
            && purchase.approvalStatus === PurchaseApprovalStatus.PENDING_REVIEW)
            || ((viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION || viewFrom === PurchaseViewFrom.CASH_BOX_REPORTING)
              && purchase.approvalStatus === PurchaseApprovalStatus.ERROR) ) {
            fetchPurchase();
          } else {
            goBack();
          }
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
        });
    } else {
      create(purchase)
        .then(() => {
          showNotification({type: 'success', message: 'Compra creada correctamente.'});
          goBack();
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
        });
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit,
    validationSchema: validationSchema,
  });

  const goBack = () => {
    navigate(-1)
  };

  const handleStatusHistoryModalOpen = () => {
    setStatusHistoryModalOpen(true);
  }

  const handleStatusHistoryModalClose = () => {
    setStatusHistoryModalOpen(false);
  }

  const handleChangeAccount = (event: SelectChangeEvent) => {
    const selectedAccount = accounts.find(acc => acc.id === event.target.value);
    formik.setFieldValue('account', selectedAccount)
  };

  const handleChangeCategory = (event: SelectChangeEvent) => {
    const selectedCategory = categories.find(cat => cat.id === event.target.value);
    formik.setFieldValue('category', selectedCategory)
  };

  const handleChangeInvoiceType = (event: SelectChangeEvent) => {
    const selectedInvoiceType = invoiceTypes.find(it => it.id === event.target.value);
    formik.setFieldValue('invoiceType', selectedInvoiceType)

    formik.setFieldValue('iva105', 0);
    formik.setFieldValue('iva21', 0);
    formik.setFieldValue('iva27', 0);
    formik.setFieldValue('iibbPerceptions', 0);
    formik.setFieldValue('ivaPerceptions', 0);
    formik.setFieldValue('netTaxed105', 0);
    formik.setFieldValue('netTaxed21', 0);
    formik.setFieldValue('netTaxed27', 0);
  };

  const handleChangeInvoiceDate = (value: Moment | null) => {
    formik.setFieldValue('invoiceDate', moment(value).format('YYYY-MM-DDThh:mm:ss'))
  };

  const handleChangeImputationPeriod = (value: Moment | null) => {
    formik.setFieldValue('imputationPeriod', moment(value).format('YYYY-MM'));
  };

  const handleChangeActive = (event: SelectChangeEvent) => {
    formik.setFieldValue('paid', event.target.value)
  };

  const handleChangePaymentMethod = (event: SelectChangeEvent) => {
    formik.setFieldValue('paymentMethod', event.target.value)
  };

  const fetchAccounts = async () => {
    getActiveAccounts().then( (response) => {
      setAccounts(response.data)
    })
  };

  const fetchCategories = async () => {
    getActiveCategories().then( (response) => {
      setCategories(response.data)
    })
  };

  const fetchInvoiceTypes = async () => {
    getActiveInvoiceTypes().then( (response) => {
      const responseData = response.data;
      setInvoiceTypes(response.data);
      if (!id) {
        formik.setFieldValue('invoiceType', responseData[0]);
      }
    })
  };

  const fetchProviders = async () => {
    getActiveProviders().then( (response) => {
      setProviders(response.data)
    })
  };

  const onInputChange = (event: React.SyntheticEvent, value: string, reason: AutocompleteInputChangeReason) => {
    if (value.length > 1) {
      findServiceOrders({keyword: value})
        .then( (response) => {
          setServiceOrders(response.data)
        })
    }
  };

  useEffect(() => {
    if (purchase.serviceOrder?.id) {
      setSelectedServiceOrder(purchase.serviceOrder);
      setServiceOrders([purchase.serviceOrder as IServiceOrder]);
    }
  }, [purchase.serviceOrder?.id]);

  useEffect(() => {
    if (purchase.id == null && preSelectedServiceOrderId) {
      getServiceOrderById(preSelectedServiceOrderId).then( (response) => {
        setSelectedServiceOrder(response.data);
        setServiceOrders([response.data as IServiceOrder]);
        formik.setFieldValue('serviceOrder', response.data);
      })
    }

  }, [preSelectedServiceOrderId]);

  const fetchPurchase = async () => {
    if (id) {
      getById(id).then( (response) => {
        let purchaseData = response.data;
        setPurchase(purchaseData)
        formik.setValues(purchaseData)
        formik.setFieldValue('invoiceDate',  moment(purchaseData.invoiceDate))
        if (purchaseData.imputationPeriod) {
          const [year, month] = purchaseData.imputationPeriod;
          formik.setFieldValue('imputationPeriod', moment({ year, month: month - 1, day: 1 }).format('YYYY-MM'));
        }
      })
    }
  };

  useEffect(() => {
    const netTaxed21 = Number(formik.values.netTaxed21) || 0;
    const iva21 = netTaxed21 * 0.21;

    formik.setFieldValue('iva21', Number(iva21).toFixed(2));
  }, [
    formik.values.netTaxed21,
  ]);

  useEffect(() => {
    const netTaxed105 = Number(formik.values.netTaxed105) || 0;
    const iva105 = netTaxed105 * 0.105;

    formik.setFieldValue('iva105', Number(iva105).toFixed(2));
  }, [
    formik.values.netTaxed105,
  ]);

  useEffect(() => {
    const netTaxed27 = Number(formik.values.netTaxed27) || 0;
    const iva27 = netTaxed27 * 0.27;

    formik.setFieldValue('iva27', Number(iva27).toFixed(2));
  }, [
    formik.values.netTaxed27,
  ]);

  useEffect(() => {
    const exemptAmount = Number(formik.values.exemptAmount) || 0;
    const iibbPerceptions = Number(formik.values.iibbPerceptions) || 0;
    const iva105 = Number(formik.values.iva105) || 0;
    const iva21 = Number(formik.values.iva21) || 0;
    const iva27 = Number(formik.values.iva27) || 0;
    const ivaPerceptions = Number(formik.values.ivaPerceptions) || 0;
    const netTaxed105 = Number(formik.values.netTaxed105) || 0;
    const netTaxed21 = Number(formik.values.netTaxed21) || 0;
    const netTaxed27 = Number(formik.values.netTaxed27) || 0;

    const totalAmount = exemptAmount + iibbPerceptions + iva105 + iva21 + iva27 + ivaPerceptions +
      netTaxed105 + netTaxed21 + netTaxed27;

    formik.setFieldValue('totalAmount', totalAmount.toFixed(2));
  }, [
    formik.values.exemptAmount,
    formik.values.iibbPerceptions,
    formik.values.iva105,
    formik.values.iva21,
    formik.values.iva27,
    formik.values.ivaPerceptions,
    formik.values.netTaxed105,
    formik.values.netTaxed21,
    formik.values.netTaxed27
  ]);

  const handleConfirmationModalClose = () => {
    setSelectedNewStatus(null);
    setConfirmationModalOpen(false);
  }

  const handleOpenChangeStatusModal = (status: PurchaseApprovalStatus) => {
    if (status === PurchaseApprovalStatus.VALIDATED) {
      setModalTitle("Validar Compra");
      setModalMessage("Al confirmar se validara la compra.")
    } else if (status === PurchaseApprovalStatus.ERROR) {
      setModalTitle("Marcar Compra con Error");
      setModalMessage("Al confirmar se marcara la compra con error.")
    } else {
      setModalTitle("Marcar Compra como Pendiente de Revision");
      setModalMessage("Al confirmar se la compra quedara pendiente de revision.")
    }
    setSelectedNewStatus(status);
    setConfirmationModalOpen(true);
  };

  const onConfirm = (comments?: string) => {
    if (selectedNewStatus) {
      let newStatus: IPurchaseApprovalChangeStatus = {
        status: selectedNewStatus,
        comments: comments ? comments : '',
      };
      changeStatus(purchase.id, newStatus)
        .then(() => {
          showNotification({type: 'success', message: 'Compra actualizada correctamente.'});
          goBack();
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
          formik.validateForm().then(() => {
            formik.setTouched(
              Object.keys(formik.values).reduce((acc: Record<string, boolean>, key: string) => {
                acc[key] = true;
                return acc;
              }, {})
            );
          });
        });
    }

    setSelectedNewStatus(null);
    setConfirmationModalOpen(false);
  };

  useEffect(() => {
    setSelectedSection(window.location.pathname.split( '/')[1])
    fetchAccounts();
    fetchCategories();
    fetchInvoiceTypes();
    fetchProviders();
    fetchPurchase();
  }, []);

  return (
    <Box
      sx={{
        px: { xs: 2},
        pt: { xs: 'calc(12px + var(--Header-height))' },
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        height: '100dvh',
        overflow: "auto"
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: { xs: 1 },
              width: '100%',
            }}
          >
            <Breadcrumbs
              size="sm"
              aria-label="breadcrumbs"
              separator={<ChevronRightRoundedIcon/>}
              sx={{ pl: 0 }}
            >
              <Typography level="h4" component="h1">
                {selectedSection === "my-cash-boxes" ? (
                    <LocalAtmIcon fontSize="small" sx={{ fontSize: 30, marginTop: -1}} />
                  ) : selectedSection === "my-liquidations" ? (
                    <CurrencyExchangeIcon fontSize="small" sx={{ fontSize: 30, marginTop: -1}} />
                  ) : (
                    <ShoppingCartIcon fontSize="small" sx={{ fontSize: 30, marginTop: -1}} />
                  )
                }
              </Typography>
              {selectedSection === "my-cash-boxes" ? (
                <Typography level="h4" component="h1">
                  <Link component={NavLink} to="/my-cash-boxes" underline={"none"}>Mis Cajas</Link>
                </Typography>
                ) : selectedSection === "my-liquidations" ? (
                <Typography level="h4" component="h1">
                  <Link component={NavLink} to="/my-liquidations" underline={"none"}>Mis Liquidaciones</Link>
                </Typography>
                ) : (
                <Typography level="h4" component="h1">
                  Control Financiero
                </Typography>
                )
              }
              {selectedSection === "my-cash-boxes" &&
                <Typography level="h4" component="h1">
                  Rendicion de Caja
                </Typography>
              }
              {selectedSection === "my-cash-boxes" &&
                <Typography level="h4" component="h1">
                    <Link component={NavLink} to={`${'/my-cash-boxes/edit/' + cashBoxId}`} underline={"none"}>{cashBoxId}</Link>
                </Typography>
              }
              {selectedSection === "my-liquidations" &&
                  <Typography level="h4" component="h1">
                      Carga de Liquidacion
                  </Typography>
              }
              {selectedSection === "my-liquidations" &&
                  <Typography level="h4" component="h1">
                      <Link component={NavLink} to={`${'/my-liquidations/edit/' + liquidationId}`} underline={"none"}>{liquidationId}</Link>
                  </Typography>
              }
              {selectedSection === "cash-boxes" &&
                <Typography level="h4" component="h1">
                    <Link component={NavLink} to='/cash-boxes' underline={"none"}>Cajas</Link>
                </Typography>
              }
              {selectedSection === "liquidations" &&
                  <Typography level="h4" component="h1">
                      <Link component={NavLink} to='/liquidations' underline={"none"}>Liquidaciones</Link>
                  </Typography>
              }
              {selectedSection === "purchases" &&
                <Typography level="h4" component="h1">
                  <Link
                    underline={"none"}
                    onClick={() => goBack()}
                    sx={{ cursor: 'pointer' }}
                  >
                    Compras
                  </Link>
                </Typography>
              }
              {selectedSection === "liquidations" &&
                <Typography level="h4" component="h1">
                  <Link component={NavLink} to={`${'/liquidations/edit/' + liquidationId}`} underline={"none"}>{liquidationId}</Link>
                </Typography>
              }
              {selectedSection === "cash-boxes" &&
                  <Typography level="h4" component="h1">
                      <Link component={NavLink} to={`${'/cash-boxes/edit/' + cashBoxId}`} underline={"none"}>{cashBoxId}</Link>
                  </Typography>
              }
              {selectedSection !== "purchases" &&
                <Typography level="h4" component="h1">
                    Compras
                </Typography>
              }
              <Typography level="h4" component="h1">
                {id ? "Editar" : "Nuevo"}
              </Typography>
            </Breadcrumbs>
            <Box>
              <CssVarsProvider>
                <ChipMaterial
                  color={PurchaseApprovalStatusColors[PurchaseApprovalStatus[formik.values.approvalStatus as keyof typeof PurchaseApprovalStatus]]}
                  label={PurchaseApprovalStatusNames[PurchaseApprovalStatus[formik.values.approvalStatus as keyof typeof PurchaseApprovalStatus]]}
                  sx={{width: 200, fontWeight: 'bold', fontSize: 15}}
                  icon={<ManageSearchIcon fontSize="medium" sx={{marginTop: -0.5}} />}
                  clickable={true}
                  onClick={() => handleStatusHistoryModalOpen()}
                />
              </CssVarsProvider>
            </Box>
          </Box>

          <ConfirmationModal
            open={confirmationModalOpen}
            onConfirm={(comments?: string) => { onConfirm(comments)}}
            onCancel={handleConfirmationModalClose}
            title={modalTitle}
            message={modalMessage}
            isDeleteAction={false}
            enableComments={true}
          />

          <StatusHistoryModal
            open={statusHistoryModalOpen}
            title={"Historial de Estados de Caja"}
            history={purchase.statusHistory}
            onCancel={handleStatusHistoryModalClose}
            historyType={"purchase"}
          />

          {id
            && purchase.cashBoxId
            && viewFrom === PurchaseViewFrom.ADMINISTRATION_PANEL &&
            <Box sx={{ width: '100%', typography: 'body1', pl:1, pr:1, pt:1 }}>
              <Alert
                sx={{ alignItems: 'flex-start', width: '100%' }}
                startDecorator={<WarningIcon />}
                variant="soft"
                color="warning"
              >
                <div>
                  <Typography level="body-sm">
                    Esta compra esta asociada a una Caja, no es posible editarla.
                  </Typography>
                </div>
              </Alert>
            </Box>
          }

          {id
            && purchase.cashBoxId
            && purchase.cashBoxStatus !== CashBoxStatus.REPORT_SUBMITTED
            && viewFrom === PurchaseViewFrom.CASH_BOX_ADMINISTRATION &&
            <Box sx={{ width: '100%', typography: 'body1', pl:1, pr:1, pt:1 }}>
              <Alert
                sx={{ alignItems: 'flex-start', width: '100%' }}
                startDecorator={<WarningIcon />}
                variant="soft"
                color="warning"
              >
                <div>
                  <Typography level="body-sm">
                    {purchase.cashBoxStatus === CashBoxStatus.CLOSE ?
                      'La Caja asociada esta Cerrada. No es posible editar la compra.'
                      :
                      'La Caja asociada no esta lista para ser validada. No es posible editar la compra.'
                    }
                  </Typography>
                  </div>
              </Alert>
            </Box>
          }

          <Box sx={{ width: '100%', typography: 'body1' }}>
            <form className="form" onSubmit={formik.handleSubmit}>
              <Grid
                container
                rowSpacing={2}
                columnSpacing={2}
                marginBlock={1}
                marginInline={0}
                sx={{ width: '100%' }}
              >
                {/*Row 1*/}
                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="account-label" shrink>Cuenta</InputLabel>
                      <Select
                        labelId="account-label"
                        id="account"
                        name="account"
                        label="account"
                        value={formik.values.account ? formik.values.account.id : ""}
                        onBlur={formik.handleBlur}
                        onChange={handleChangeAccount}
                        disabled={[PurchaseViewFrom.CASH_BOX_REPORTING, PurchaseViewFrom.LIQUIDATION_REPORTING].includes(viewFrom)}
                      >
                        {accounts?.map((account) => (
                          <MenuItem key={account.id} value={account.id}>{account.name}</MenuItem>
                        ))}
                      </Select>
                      {formik.touched.account && formik.errors.account ? (
                        <span className="Error-alert">{String(formik.errors.account)}</span>
                      ) : null}
                    </FormControl>
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="category-label" shrink>Categoria / Rubro</InputLabel>
                      <Select
                        labelId="category-label"
                        id="category"
                        name="category"
                        label="category"
                        value={formik.values.category ? formik.values.category.id : ""}
                        onBlur={formik.handleBlur}
                        onChange={handleChangeCategory}
                        disabled={[PurchaseViewFrom.CASH_BOX_REPORTING, PurchaseViewFrom.LIQUIDATION_REPORTING].includes(viewFrom)}
                      >
                        {categories?.map((category) => (
                          <MenuItem key={category.id} value={category.id}>{category.name}</MenuItem>
                        ))}
                      </Select>
                      {formik.touched.category && formik.errors.category ? (
                        <span className="Error-alert">{String(formik.errors.category)}</span>
                      ) : null}
                    </FormControl>
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="invoiceType-label" shrink>Tipo</InputLabel>
                      <Select
                        labelId="invoiceType-label"
                        id="invoiceType"
                        name="invoiceType"
                        label="invoiceType"
                        value={formik.values.invoiceType ? formik.values.invoiceType.id : ""}
                        onBlur={formik.handleBlur}
                        onChange={handleChangeInvoiceType}
                      >
                        {invoiceTypes?.map((invoiceType) => (
                          <MenuItem key={invoiceType.id} value={invoiceType.id}>{invoiceType.name}</MenuItem>
                        ))}
                      </Select>
                      {formik.touched.invoiceType && formik.errors.invoiceType ? (
                        <span className="Error-alert">{String(formik.errors.invoiceType)}</span>
                      ) : null}
                    </FormControl>
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="exemptAmount"
                      label="Exento"
                      name="exemptAmount"
                      variant="filled"
                      type={"number"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.exemptAmount}
                      error={!!(formik.touched.exemptAmount && formik.errors.exemptAmount)}
                      slotProps={{ inputLabel: {shrink: true}}}
                    />
                    {formik.touched.exemptAmount && formik.errors.exemptAmount ? (
                      <span className="Error-alert">{formik.errors.exemptAmount}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                {/*Row 2*/}
                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="paid-label" shrink>Pagado</InputLabel>
                      <Select
                        labelId="paid-label"
                        id="paid"
                        name="paid"
                        label="paid"
                        value={formik.values.paid}
                        onBlur={formik.handleBlur}
                        onChange={handleChangeActive}
                      >
                        <MenuItem key="true" value="true">Si</MenuItem>
                        <MenuItem key="false" value="false">No</MenuItem>
                      </Select>
                      {formik.touched.paid && formik.errors.paid ? (
                        <span className="Error-alert">{formik.errors.paid}</span>
                      ) : null}
                    </FormControl>
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="paymentMethod-label" shrink>Forma de Pago</InputLabel>
                      <Select
                        labelId="paymentMethod-label"
                        id="paymentMethod"
                        name="paymentMethod"
                        label="paymentMethod"
                        value={formik.values.paymentMethod ? formik.values.paymentMethod : ""}
                        onBlur={formik.handleBlur}
                        onChange={handleChangePaymentMethod}
                        disabled={[PurchaseViewFrom.CASH_BOX_REPORTING, PurchaseViewFrom.LIQUIDATION_REPORTING].includes(viewFrom)}
                      >
                        {Object
                          .keys(PaymentMethod)
                          .map((key) => (
                            <MenuItem key={key} value={PaymentMethod[key as keyof typeof PaymentMethod]}>
                              {PaymentMethodNames[PaymentMethod[key as keyof typeof PaymentMethod]]}
                            </MenuItem>
                          ))}
                      </Select>
                      {formik.touched.paymentMethod && formik.errors.paymentMethod ? (
                        <span className="Error-alert">{String(formik.errors.paymentMethod)}</span>
                      ) : null}
                    </FormControl>
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="netTaxed21"
                      label="Neto Grabado 21%"
                      name="netTaxed21"
                      variant="filled"
                      type={"number"}
                      disabled={![1, 6].includes(formik.values.invoiceType?.id)}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.netTaxed21}
                      error={!!(formik.touched.netTaxed21 && formik.errors.netTaxed21)}
                      slotProps={{ inputLabel: {shrink: true}}}
                    />
                    {formik.touched.netTaxed21 && formik.errors.netTaxed21 ? (
                      <span className="Error-alert">{formik.errors.netTaxed21}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="iva21"
                      label="IVA 21%"
                      name="iva21"
                      variant="filled"
                      type={"number"}
                      disabled={![1, 6].includes(formik.values.invoiceType?.id)}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.iva21}
                      error={!!(formik.touched.iva21 && formik.errors.iva21)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true} }}
                    />
                    {formik.touched.iva21 && formik.errors.iva21 ? (
                      <span className="Error-alert">{formik.errors.iva21}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                {/*Row 3*/}
                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        name="start"
                        label="Fecha"
                        format="DD/MM/YYYY"
                        value={formik.values.invoiceDate ? moment(formik.values.invoiceDate) : null }
                        onChange={handleChangeInvoiceDate}
                        slotProps={{
                          textField: {
                            variant: 'filled',
                            fullWidth: true,
                            onChange: formik.handleChange,
                            onBlur: formik.handleBlur,
                            error: formik.touched.invoiceDate && Boolean(formik.errors.invoiceDate),
                            InputLabelProps: {
                              shrink:  true
                            }
                          }
                        }} />
                    </LocalizationProvider>
                    {formik.touched.invoiceDate && formik.errors.invoiceDate ? (
                      <span className="Error-alert">{formik.errors.invoiceDate}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        views={["year", "month"]}
                        name="start"
                        label="Periodo IVA"
                        format="MM-YYYY"
                        value={formik.values.imputationPeriod ? moment(formik.values.imputationPeriod) : null }
                        onChange={handleChangeImputationPeriod}
                        disabled={[PurchaseViewFrom.CASH_BOX_REPORTING, PurchaseViewFrom.LIQUIDATION_REPORTING].includes(viewFrom)}
                        slotProps={{
                          textField: {
                            variant: 'filled',
                            fullWidth: true,
                            onChange: formik.handleChange,
                            onBlur: formik.handleBlur,
                            error: formik.touched.imputationPeriod && Boolean(formik.errors.imputationPeriod),
                            InputLabelProps: {
                              shrink:  true
                            }
                          }
                        }} />
                    </LocalizationProvider>
                    {formik.touched.imputationPeriod && formik.errors.imputationPeriod ? (
                      <span className="Error-alert">{formik.errors.imputationPeriod}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="netTaxed105"
                      label="Neto Grabado 10.5%"
                      name="netTaxed105"
                      variant="filled"
                      type={"number"}
                      disabled={![1, 6].includes(formik.values.invoiceType?.id)}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.netTaxed105}
                      error={!!(formik.touched.netTaxed105 && formik.errors.netTaxed105)}
                      slotProps={{ inputLabel: {shrink: true}}}
                    />
                    {formik.touched.netTaxed105 && formik.errors.netTaxed105 ? (
                      <span className="Error-alert">{formik.errors.netTaxed105}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="iva105"
                      label="IVA 10.5%"
                      name="iva105"
                      variant="filled"
                      type={"number"}
                      disabled={![1, 6].includes(formik.values.invoiceType?.id)}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.iva105}
                      error={!!(formik.touched.iva105 && formik.errors.iva105)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true}}}
                    />
                    {formik.touched.iva105 && formik.errors.iva105 ? (
                      <span className="Error-alert">{formik.errors.iva105}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                {/*Row 4*/}
                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="invoiceNumber"
                      label="Numero de Comprobante"
                      name="invoiceNumber"
                      variant="filled"
                      type={"text"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.invoiceNumber}
                      error={!!(formik.touched.invoiceNumber && formik.errors.invoiceNumber)}
                      slotProps={{ inputLabel: {shrink: true}}}
                    />
                    {formik.touched.invoiceNumber && formik.errors.invoiceNumber ? (
                      <span className="Error-alert">{formik.errors.invoiceNumber}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="role-label" shrink>Orden de Servicio</InputLabel>
                      <Autocomplete
                        id="serviceOrder-autocomplete"
                        value={selectedServiceOrder}
                        getOptionLabel={(serviceOrder) =>
                          `${serviceOrder.number}`
                        }
                        onInputChange={onInputChange}
                        options={serviceOrders}

                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onChange={(e, value) => {
                          setSelectedServiceOrder(value);
                          formik.setFieldValue('serviceOrder', value);
                        }}
                        fullWidth
                        disabled={preSelectedServiceOrderId !== null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant={"filled"}
                            slotProps={{ inputLabel: {shrink: true, type: 'search'}}}
                            onBlur={formik.handleBlur}
                          />
                        )}
                      />
                      {formik.touched.serviceOrder && formik.errors.serviceOrder ? (
                        <span className="Error-alert">{String(formik.errors.serviceOrder)}</span>
                      ) : null}
                    </FormControl>
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="netTaxed27"
                      label="Neto Grabado 27%"
                      name="netTaxed27"
                      variant="filled"
                      type={"number"}
                      disabled={![1, 6].includes(formik.values.invoiceType?.id)}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.netTaxed27}
                      error={!!(formik.touched.netTaxed27 && formik.errors.netTaxed27)}
                      slotProps={{ inputLabel: {shrink: true}}}
                    />
                    {formik.touched.netTaxed27 && formik.errors.netTaxed27 ? (
                      <span className="Error-alert">{formik.errors.netTaxed27}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="iva27"
                      label="IVA 27%"
                      name="iva27"
                      variant="filled"
                      type={"number"}
                      disabled={![1, 6].includes(formik.values.invoiceType?.id)}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.iva27}
                      error={!!(formik.touched.iva27 && formik.errors.iva27)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true} }}
                    />
                    {formik.touched.iva27 && formik.errors.iva27 ? (
                      <span className="Error-alert">{formik.errors.iva27}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                {/*Row 5*/}
                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <Autocomplete
                      id="provider"
                      value={formik.values.provider}
                      getOptionLabel={(provider) =>
                        `${provider?.name || ''} - CUIT: ${provider?.cuit || '...'}`
                      }
                      options={providers}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id}
                      onChange={(e, value) => {
                        formik.setFieldValue('provider', value);
                      }}
                      fullWidth
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="filled"
                          name="provider"
                          label="Proveedor"
                          slotProps={{ inputLabel: { shrink: true } }}
                          onBlur={formik.handleBlur}
                          error={!!(formik.touched.provider && formik.errors.provider)}
                        />
                      )}
                    />
                    {formik.touched.provider && formik.errors.provider ? (
                      <span className="Error-alert">{String(formik.errors.provider)}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="ivaPerceptions"
                      label="Precepciones IVA"
                      name="ivaPerceptions"
                      variant="filled"
                      type={"number"}
                      disabled={![1, 6].includes(formik.values.invoiceType?.id)}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.ivaPerceptions}
                      error={!!(formik.touched.ivaPerceptions && formik.errors.ivaPerceptions)}
                      slotProps={{ inputLabel: {shrink: true}}}
                    />
                    {formik.touched.ivaPerceptions && formik.errors.ivaPerceptions ? (
                      <span className="Error-alert">{formik.errors.ivaPerceptions}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={3} md={3} sm={3} xs={3}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="iibbPerceptions"
                      label="Precepciones IIBB"
                      name="iibbPerceptions"
                      variant="filled"
                      type={"number"}
                      disabled={![1, 6].includes(formik.values.invoiceType?.id)}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.iibbPerceptions}
                      error={!!(formik.touched.iibbPerceptions && formik.errors.iibbPerceptions)}
                      slotProps={{ inputLabel: {shrink: true}}}
                    />
                    {formik.touched.iibbPerceptions && formik.errors.iibbPerceptions ? (
                      <span className="Error-alert">{formik.errors.iibbPerceptions}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                {/*Row 6*/}
                <Grid xl={6} md={6} sm={6} xs={6}>
                  <Card sx={{height: 57, padding: 1, margin:0}}>
                    <Stack direction={"row"} justifyContent={"space-between"}>
                      <Stack direction={"row"} justifyContent={"center"}>
                        <Typography sx={{fontWeight: "bold"}} pt={1} pr={1}>
                          Comprobante:
                        </Typography>
                        {formik.values.uploadInvoiceFile ?
                          <Chip
                            variant="outlined"
                            color="neutral"
                            size="lg"
                          >
                            {formik.values.uploadInvoiceFile.name}
                          </Chip>
                          :
                          purchase?.invoiceFile ?
                            <Chip
                              variant="outlined"
                              color="neutral"
                              size="lg"
                              onClick={() => downloadFile(purchase?.invoiceFile)}
                              endDecorator={<DownloadForOfflineIcon sx={{ fontSize: 30}}/>}
                            >
                              {purchase.invoiceFile.fileName}
                            </Chip>
                            :
                            <Typography pt={1} pr={1}>
                              No hay archivo adjunto
                            </Typography>
                        }
                      </Stack>
                      <Stack direction={"row"} justifyContent={"space-between"}>
                        <input
                          id="uploadInvoiceFile"
                          name="uploadInvoiceFile"
                          type="file"
                          accept=".pdf,application/pdf"
                          style={{display: 'none'}}
                          onChange={(event) => {
                            if (event.currentTarget.files && event.currentTarget.files.length > 0) {
                              const newFile = event.currentTarget.files[0];
                              formik.setFieldValue("uploadInvoiceFile", newFile);
                            }
                          }}
                        />
                        <IconButton onClick={() => document.getElementById('uploadInvoiceFile')?.click()}>
                          <CloudUploadIcon sx={{ fontSize: 40}} />
                        </IconButton>
                      </Stack>
                    </Stack>
                    {formik.touched.uploadInvoiceFile && formik.errors.uploadInvoiceFile ? (
                      <span className="Error-alert">{formik.errors.uploadInvoiceFile}</span>
                    ) : null}
                  </Card>
                </Grid>

                <Grid xl={6} md={6} sm={6} xs={6}>
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="totalAmount"
                      label="Total"
                      name="totalAmount"
                      variant="filled"
                      type={"number"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.totalAmount}
                      error={!!(formik.touched.totalAmount && formik.errors.totalAmount)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: true} }}
                    />
                    {formik.touched.totalAmount && formik.errors.totalAmount ? (
                      <span className="Error-alert">{formik.errors.totalAmount}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

                <Grid xl={12} md={12} sm={12} xs={12} >
                  <CssVarsProvider>
                    <TextField
                      fullWidth
                      id="comments"
                      label="Comentarios"
                      name="comments"
                      variant="filled"
                      type={"text"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.comments}
                      error={!!(formik.touched.comments && formik.errors.comments)}
                      slotProps={{ inputLabel: {shrink: true}, input: {readOnly: false}}}
                      multiline
                      rows={5}
                      sx={{mb: '3px'}}
                    />
                    {formik.touched.comments && formik.errors.comments ? (
                      <span className="Error-alert">{formik.errors.comments}</span>
                    ) : null}
                  </CssVarsProvider>
                </Grid>

              </Grid>

              <Stack direction="row" justifyContent="space-between" spacing={2} pr={1} pl={1}>
                <Stack direction="row" justifyContent="flex-start" spacing={2}>
                  {viewFrom === PurchaseViewFrom.CASH_BOX_ADMINISTRATION
                    && formik.values.approvalStatus === PurchaseApprovalStatus.PENDING_REVIEW
                    && formik.values.cashBoxStatus === CashBoxStatus.REPORT_SUBMITTED &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(PurchaseApprovalStatus.ERROR)}
                          variant="solid"
                          color="danger"
                          endDecorator={<ErrorOutlineIcon />}>
                          Marcar con Error
                      </Button>
                  }

                  {viewFrom === PurchaseViewFrom.CASH_BOX_ADMINISTRATION
                    && formik.values.approvalStatus === PurchaseApprovalStatus.PENDING_REVIEW
                    && formik.values.cashBoxStatus === CashBoxStatus.REPORT_SUBMITTED &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(PurchaseApprovalStatus.VALIDATED)}
                          variant="solid"
                          color="success"
                          endDecorator={<CheckCircleOutlineIcon />}>
                          Validar Compra
                      </Button>
                  }

                  {viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION
                    && formik.values.approvalStatus === PurchaseApprovalStatus.PENDING_REVIEW
                    && formik.values.liquidationStatus === LiquidationStatus.SUBMITTED &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(PurchaseApprovalStatus.ERROR)}
                          variant="solid"
                          color="danger"
                          endDecorator={<ErrorOutlineIcon />}>
                          Marcar con Error
                      </Button>
                  }

                  {viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION
                    && formik.values.approvalStatus === PurchaseApprovalStatus.PENDING_REVIEW
                    && formik.values.liquidationStatus === LiquidationStatus.SUBMITTED &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(PurchaseApprovalStatus.VALIDATED)}
                          variant="solid"
                          color="success"
                          endDecorator={<CheckCircleOutlineIcon />}>
                          Validar Compra
                      </Button>
                  }

                  {viewFrom === PurchaseViewFrom.CASH_BOX_REPORTING && formik.values.approvalStatus === PurchaseApprovalStatus.ERROR &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(PurchaseApprovalStatus.PENDING_REVIEW)}
                          variant="solid"
                          color="success"
                          endDecorator={<CheckCircleOutlineIcon />}>
                          Lista para validar
                      </Button>
                  }

                  {viewFrom === PurchaseViewFrom.LIQUIDATION_REPORTING && formik.values.approvalStatus === PurchaseApprovalStatus.ERROR &&
                      <Button
                          onClick={() => handleOpenChangeStatusModal(PurchaseApprovalStatus.PENDING_REVIEW)}
                          variant="solid"
                          color="success"
                          endDecorator={<CheckCircleOutlineIcon />}>
                          Lista para validar
                      </Button>
                  }
                </Stack>

                <Stack direction="row" justifyContent="flex-end" spacing={2}>
                  <Button onClick={() => goBack()} variant="outlined" endDecorator={<ArrowBackIosNew />}>Volver</Button>
                  { viewFrom === PurchaseViewFrom.ADMINISTRATION_PANEL && !(id && purchase.cashBoxId) &&
                    <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>
                  }

                  { viewFrom === PurchaseViewFrom.CASH_BOX_ADMINISTRATION
                    && (id && purchase.cashBoxId && purchase.cashBoxStatus === CashBoxStatus.REPORT_SUBMITTED) &&
                      <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>
                  }

                  { viewFrom === PurchaseViewFrom.LIQUIDATION_ADMINISTRATION
                    && (id && purchase.liquidationId && purchase.liquidationStatus === LiquidationStatus.SUBMITTED) &&
                      <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>
                  }

                  { viewFrom === PurchaseViewFrom.CASH_BOX_REPORTING
                    && (purchase.approvalStatus === PurchaseApprovalStatus.PENDING_REVIEW
                      || purchase.approvalStatus === PurchaseApprovalStatus.ERROR) &&
                      <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>
                  }

                  { viewFrom === PurchaseViewFrom.LIQUIDATION_REPORTING
                    && (purchase.approvalStatus === PurchaseApprovalStatus.PENDING_REVIEW
                      || purchase.approvalStatus === PurchaseApprovalStatus.ERROR) &&
                      <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>
                  }
                </Stack>
              </Stack>
            </form>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};


